import { getKnownTracker } from "../../lib/getKnownTracker";
import type { KnownTracker } from "../../lib/KnownTrackers";
import { EventsTableAnalysisResults } from './EventsTableAnalysisResults';


export const getTrackingDomainReportState = ({
	originAndDestinationUrlsObserver, cookiesObserver, searchResultsObserver, codeBehaviorsObserver }: EventsTableAnalysisResults) => {
	const { sourceRegisteredDomainToDestinations } = originAndDestinationUrlsObserver;
	const searchResultsBySourceRegisteredDomain = searchResultsObserver.searchResultsBySourceRegisteredDomain;
	const searchResultsBySourceRegisteredDomainMap = new Map(searchResultsBySourceRegisteredDomain?.map(s => [s.sourceRegisteredDomain, s.destinations]));
	const resultsBySourceRegisteredDomain = sourceRegisteredDomainToDestinations.map(([sourceRegisteredDomain, destinations]) => {
		const searchResultsByDestination = new Map(
			(searchResultsBySourceRegisteredDomainMap.get(sourceRegisteredDomain) ?? []).map(d => ([d.destinationRegisteredDomain, d])));
		const resultsByDestinationRegisteredDomain = [...destinations.values()].map((destination) => {
			const { registeredDomain: destinationRegisteredDomain, domains } = destination;
			const cookies = [...(
				cookiesObserver.bySourceRegisteredDomainDestinationRegisteredDomain
					.get(sourceRegisteredDomain)
					?.get(destinationRegisteredDomain)
					?.values() ?? [])
			];;
			const searchResults = searchResultsByDestination.get(destinationRegisteredDomain);
			const codeBehavior = codeBehaviorsObserver?.byPageRegisteredDomainAndCodeRegisteredDomain.get(sourceRegisteredDomain)?.get(destinationRegisteredDomain);
			const destinationDomains = [...domains.values()];
			let knownTracker: KnownTracker | undefined = getKnownTracker(destinationRegisteredDomain);
			if (knownTracker == null) {
				destinationDomains.find(d => (knownTracker = getKnownTracker(d.domain)) != null);
			}

			return {
				destinationRegisteredDomain, cookies, searchResults, codeBehavior,
				destinationDomains, knownTracker
			};
		}).sort((a, b) => (a.knownTracker?.organizationKnownAs ?? a.destinationRegisteredDomain).localeCompare(
			b.knownTracker?.organizationKnownAs ?? b.destinationRegisteredDomain));
		return { sourceRegisteredDomain, resultsByDestinationRegisteredDomain };
	}).sort((a, b) => b.resultsByDestinationRegisteredDomain.length - a.resultsByDestinationRegisteredDomain.length);
	return resultsBySourceRegisteredDomain;
};
export type TrackingDomainReportState = ReturnType<typeof getTrackingDomainReportState>;



